import AppCard from "../../Cards/AppCard";
import AppEmptyState from "../../../../elements/AppEmptyState";

interface Props {
  app: any;
}

const Dependencies = ({ app }: Props) => {
  if (!app?.Dependencies?.length) {
    return (
      <AppEmptyState
        title="No Dependencies"
        description="There are no dependencies required for this app."
        className="w-100 tw:mt-8"
      />
    );
  }

  return (
    <div className="tw:flex tw:flex-col">
      <h4 className="tw:mt-8">Required Apps</h4>
      <span className="">
        {app.Name} requires the installation of the following products to work
        properly:
      </span>
      <div className="d-flex flex-wrap mt-5" style={{ gap: 10 }}>
        {app.Dependencies.map((dependency: any) => {
          return <AppCard key={dependency?.id} app={dependency} />;
        })}
      </div>
    </div>
  );
};

export default Dependencies;
